import { useEffect, useState } from 'react';
import { extractSearchParams } from '../util/utils';
import { redeemToken } from '../api';
import { RequestStatus } from '../util/app.types';
import { RedeemTokenTypes } from '../views/RedeemToken';

export const useRedeemEmailConfirmationToken = (
  searchParams: URLSearchParams,
) => {
  const [requestStatus, setRequestStatus] = useState(RequestStatus.Pending);

  useEffect(() => {
    const redeemEmailConfirmationTokenToken = async (
      token: string,
      email: string,
    ) => {
      try {
        const result = await redeemToken(
          RedeemTokenTypes.EmailConfirmation,
          token,
          email,
        );
        const json = await result.json();
        setRequestStatus(
          json?.success ? RequestStatus.Succeeded : RequestStatus.Failed,
        );
      } catch {
        setRequestStatus(RequestStatus.Failed);
      }
    };

    const { token, email } = extractSearchParams(searchParams);

    if (!token || !email) {
      setRequestStatus(RequestStatus.InvalidParams);
      return;
    }

    redeemEmailConfirmationTokenToken(token, email);
  }, [searchParams]);

  return requestStatus;
};
